<template>
  <div :id="'ga_'+adData.position" v-if="data && data.id" :class="{'d-none' : !is_active}">
    <div :id="id"></div>
    <div class="a-ph text-center font-style-italic" v-show="is_active" :class="label">Hirdetés</div>
  </div>
</template>
<script>
export default {
  name: "GoogleAd",
  props: ["data", "label"],
  beforeCreate() {
    window.googletag.cmd.push(() => {
      window.googletag.destroySlots();
    });
  },
  data() {
    return {
        adData: this.data ? this.data : {},
        is_active : false,
    }
  },
  computed: {
    path() {
      return this.adData.path; //sring
    },
    size() {
      if(!Array.isArray(this.adData.size)) {
          return JSON.parse(this.adData.size);
      }

      return this.adData.size; //array list of arrays
    },
    id() {
      return this.adData.id; //string
    },
    isActive() {
      if(this.adData && this.adData.id) {
        //return $("#" + this.adData.id).css("display") === "block";
        //return ($("#" + this.adData.id).children().length > 0 && $("#" + this.adData.id).css("display") === "block");

        return $("#" + this.adData.id).children().length > 0 && $("#" + this.adData.id).children().first().children().length > 0;
      }
      return false;
    },
  },
  mounted() {
    let vm = this;
    setTimeout(function() {
      vm.init();
    }, 1500);

    /*
    let vm = this;
      setInterval(function() {
          console.log('is active: ', vm.isActive(), 'disp: ', "#" + vm.adData.id, $("#" + vm.adData.id).css("display"));
      }, 1500);
*/
  },
  methods: {
    init() {
      let vm = this;
      //console.log('GA INIT data?', this.adData);
      if(this.adData && this.adData.id) {
        //console.log('loading GOOGLE AD ('+(this.isActive ? 'active' : 'inactive')+'): ' , vm.adData.path, ' / ', vm.adData.size);

        window.googletag.cmd.push(() => {
          window.googletag
                  .defineSlot(vm.adData.path, Array.isArray(vm.adData.size) ? vm.adData.size : JSON.parse(vm.adData.size), vm.adData.id)
                  .addService(window.googletag.pubads());
          window.googletag.pubads().collapseEmptyDivs();
          window.googletag.pubads().enableSingleRequest();
          window.googletag.enableServices();
          window.googletag.display(vm.id);

          this.$emit("is-active", {
            position: this.adData.position,
            is_active: this.isActive,
          });
        });

        window.googletag.cmd.push(function() { googletag.display(vm.id); });
        this.$set(this.adData, 'is_active', true);
        this.is_active = true;
        //console.log('data is active? ', this.adData, 'is active? ', this.adData.is_active);
      }
    },
    handleAds() {
      if(this.isActive) {
        let regular_ad = this.adData.position.substr(1, this.adData.position.length -1);
        $('#'+regular_ad).attr('style', 'display:none');
      } else {
      }
    },
  },
  watch: {
    data: function(newVal) {
      if(newVal) {
        this.adData = newVal;
        this.handleAds();
      }
    }
  }
};
</script>

<style>
  .vertical {
    position: absolute;
    transform: rotate3d(1, 1, 23, 269deg);
    left: -15px;
    top: 40px;
  }
</style>
